import Service from '@ember/service';
import { service } from '@ember/service';
import { load as loadDatabookFromPackage } from '@ebiz/aditools-databook';
import Constants from '../utils/constants';

// Module-level cache — survives Ember container teardown between tests
let _databookCache = null;
let _loadingPromise = null;

export function resetDatabookCache() {
  _databookCache = null;
  _loadingPromise = null;
}

export default class DataService extends Service {
  @service('aditools-site') site;
  @service('aditools-analytics') analytics;

  databook = null;

  async getDatabookGridData(pst, analogHomeUrl) {
    let viewData = null;
    // let startTime = new Date().getTime();

    if (!this.databook) {
      try {
        await this.loadDatabook();
      } catch (error) {
        console.error('Error loading databook: ', error);
      }
    }

    const databookId = Constants.PST_DATABOOK_MAPPING[pst.id];

    viewData = this.databook ? this.databook.details[databookId] : null;

    if (viewData && viewData.columns) {
      let categoryData = null;
      categoryData = viewData;

      let data = [];

      viewData.columns.forEach((param) => {
        if (param.field !== 'partNumber') {
          param.displayInDefaultView = pst.supportedParameters.includes(
            param.field,
          )
            ? true
            : false;
        }
      });

      categoryData.data.forEach((item) => {
        if (analogHomeUrl && item.partNumber.generic) {
          const generic = item.partNumber.generic.toUpperCase();
          item.productPage = `${analogHomeUrl}/${generic}`;
        }
      });

      if (
        pst.supportPartsForParameters &&
        pst.supportPartsForParameters.length
      )
        console.info(
          `Pst ${
            pst.id
          } requires parts to have data for at least one of the following parameters: [${pst.supportPartsForParameters.join(
            ', ',
          )}]`,
        );

      data = categoryData.data.filter((item) => {
        // Filter out parts that are not supported
        if (
          pst.supportedParts &&
          pst.supportedParts.length &&
          !pst.supportedParts.includes(item.name)
        )
          return false;
        else if (
          pst.unsupportedParts &&
          pst.unsupportedParts.length &&
          pst.unsupportedParts.includes(item.name)
        )
          return false;
        // Filter out parts that don't have data for any of these parameters
        else if (
          pst.supportPartsForParameters &&
          pst.supportPartsForParameters.length
        ) {
          // Find all data for required parameters
          const parameterData = Object.keys(item)
            .filter((key) => pst.supportPartsForParameters.includes(key))
            .map((key) => {
              const parameter = item[key];
              return parameter.value && parameter.value.length
                ? parameter.value[0]
                : null;
            });

          const dataFound = parameterData.some(
            (parameterValue) => parameterValue,
          );
          if (!dataFound)
            console.warn(
              `Part ${item.name}; Data was not found for any of the required parameters`,
            );
          return dataFound;
        } else return true;
      });
      categoryData.data = data;

      return {
        view: viewData,
        data: categoryData,
      };
    } else {
      return null;
    }
  }

  async loadDatabook() {
    if (_databookCache) {
      this.databook = _databookCache;
      return;
    }

    if (_loadingPromise) {
      this.databook = await _loadingPromise;
      return;
    }

    const fetchUrl =
      window.location.hostname === 'localhost'
        ? `${window.location.protocol}//${window.location.host}/`
        : `${this.site.SiteUrl}/`;

    _loadingPromise = loadDatabookFromPackage(
      fetchUrl,
      [
        { deviceType: 'opAmp' },
        { deviceType: 'voltageReference' },
        { deviceType: 'multiplyingDac' },
        { deviceType: 'voltageOutputDac' },
        { deviceType: 'currentSourceDac' },
        { deviceType: 'currentSourceSinkDac' },
        { deviceType: 'fastPrecisionDac' },
      ],
      {},
      {},
    );

    this.databook = await _loadingPromise;
    _databookCache = this.databook;
    _loadingPromise = null;
  }
}
